import type { ReactNode } from 'react';

import { cn } from '@/ui/utils/classnames';

type ResponsiveLayoutProps = {
  children: ReactNode;
  className?: string;
  header?: ReactNode;
};

function ResponsiveLayout({
  children,
  header,
  className,
}: ResponsiveLayoutProps) {
  return (
    <div className="flex size-full flex-col overflow-y-auto bg-white scrollbar-hide theme-dark:bg-[#151515] md:bg-gray-100 theme-dark:md:bg-[#000]">
      {header}
      <main
        className={cn(
          'grid w-full flex-shrink-0 flex-grow grid-cols-4 gap-x-3 overflow-y-auto px-6 scrollbar-hide md:grid-cols-8 md:gap-x-6 md:px-12',
          className,
        )}
      >
        {children}
      </main>
    </div>
  );
}

export default ResponsiveLayout;
